import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Typography,
  Paper,
  Popper,
  ClickAwayListener
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const platforms = ["Android", "Web", "iOS"];

export default function PlatformMultiSelect({ value, onChange }) {

  const [open, setOpen] = useState(false);
  const [internalSelected, setInternalSelected] = useState([]);

  const isControlled = Array.isArray(value) && typeof onChange === "function";
  const selected = isControlled ? value : internalSelected;

  const updateSelected = (next) => {
    if (isControlled) {
      onChange(next);
    } else {
      setInternalSelected(next);
    }
  };

  const anchorRef = useRef(null);

  const handleSelect = (platform) => {
    if (selected.includes(platform)) {
      updateSelected(selected.filter((p) => p !== platform));
    } else {
      updateSelected([...selected, platform]);
    }
  };

  const handleSelectAll = () => {
    if (selected.length === platforms.length) {
      updateSelected([]);
    } else {
      updateSelected(platforms);
    }
  };

  const buttonLabel = () => {
    if (selected.length === 0) return "All Platform";
    if (selected.length === 1) return selected[0];
    return `${selected[0]} +${selected.length - 1}`;
  };

  return (
    <Box>

      {/* Button */}
      <Button
        ref={anchorRef}
        onClick={() => setOpen(!open)}
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          height: "40px",
          width: "200px",
          border: "1px solid #E8E8E8",
          color: "#3E3E3E",
          justifyContent: "space-between"
        }}
      >
        {buttonLabel()}
      </Button>

      {/* Dropdown */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>

          <Paper
            sx={{
              width: anchorRef.current?.clientWidth,
              mt: 1,
              p: 2,
              borderRadius: "12px"
            }}
          >

            {/* Select All */}
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={selected.length === platforms.length}
                onChange={handleSelectAll}
                 sx={{
      color: "#999", 
      "&.Mui-checked": {
        color: "#ff4a4a",  
      },
    }}
              />
              <Typography fontSize={14}>
                Select All
              </Typography>
            </Box>

            {/* Platform List */}
            {platforms.map((platform) => (

              <Box
                key={platform}
                display="flex"
                alignItems="center"
              >
                <Checkbox
                  checked={selected.includes(platform)}
                  onChange={() => handleSelect(platform)}
                   sx={{
      color: "#999",  
      "&.Mui-checked": {
        color: "#ff4a4a",    
      },
    }}
                />

                <Typography fontSize={14}>
                  {platform}
                </Typography>

              </Box>

            ))}

          </Paper>

        </ClickAwayListener>
      </Popper>

    </Box>
  );
}